module.exports = {
  localeName: 'nl-BE',
  momentFormat: 'DD/MM/YYYY',
};
